<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <ng-container *ngIf="!modalData.isInhOuseGroupOrder">
      <div class="ya-bottomsheet-title-icon">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
      </div>
    </ng-container>
    <div @plopInOut class="header-content">
      <ng-container *ngIf="!modalData.isInhOuseGroupOrder">
        <div class="checkmark-container">
          <div class="inline-icon online-account-checkmark" inlineSVG="shop-icons.svg#ya-hypersoft-check-voll"></div>
        </div>
      </ng-container>
      <div class="info">
        <h2
          [langkey]="!modalData.isInhOuseGroupOrder?'phContinueShoppingDialog_Label':'phContinueShoppingDialog_Label_IHGroup'">
        </h2>
      </div>
    </div>
    <div class="item">
      <div class="item-content">
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <div class="aspect-ration-img-box">
              <img class="ya_image" [src]="modalData.itemConfig.image" alt="" />
            </div>
          </div>
        </div>
        <div class="item-info">
          <div class="item-info-wrapper">
            <div class="item-detail">
              <h2 class="title">
                {{modalData.itemConfig.label}}
              </h2>
            </div>
            <div class="item-price-detail">
              <div class="item-count">{{modalData.itemConfig.count}}</div>
              <div class="item-amount">{{(setItemPrice(modalData.itemConfig.isWebVoucher))}}</div>
            </div>
          </div>
          <ng-container *ngIf="!modalData.itemConfig.isWebVoucher">
            <ng-container *ngIf="modalData.itemConfig.extras && modalData.itemConfig.extras.length>0">
              <div class="extra-item-wrapper">
                <div [id]="'prucudtExtraContainer---'" class="extra-item-container active">
                  <p>{{setExtraString()}} </p>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="modalData.itemConfig.isWebVoucher">
            <div class="webVoucher-content--detail">
              <ng-container *ngIf="modalData.itemConfig.displayPersonCount && !modalData.itemConfig.isFreeAmount">
                <div class="person-detail">
                  <span class="person-count">{{modalData.itemConfig.personCount}}</span><span
                    [langkey]="modalData.itemConfig.personCount>1? 'phWebvoucher_Detail_Selected_Number_Of_Persons' :'phWebvoucher_Detail_Selected_Single_Person'"></span>
                </div>
              </ng-container>
              <ng-container *ngIf="modalData.itemConfig.showDeliveryType">
                <div class="delivery-detail">
                  <span
                    [langkey]="isWebVoucherMailDelivery(modalData.itemConfig.deliveryType)?'phWebvoucher_Detail_Email_Delivery':'phWebvoucher_Detail_Post_Delivery'"></span>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <ng-container *ngIf="modalData.isInhOuseGroupOrder &&  modalData.itemConfig.canComment ">
      <div class="comment-area">
        <div [id]="'comment'+ modalData.itemConfig.id"
          [ngClass]="['item-comment', commentVisibleInitilize && showComment()?'show-comment':'']">
          <textarea class="ya-caption" minlength="1" maxlength="200"
            (blur)="closeEmptyTextArea($event.currentTarget.value, modalData.itemConfig.id)" tabindex="-1" id="item1"
            [(ngModel)]="modalData.itemConfig.comment"></textarea>
        </div>
        <div [id]="'commentLink'+modalData.itemConfig.id"
          [ngClass]="['item-comment-link', commentVisibleInitilize && showComment() ?'hide-anmerkung':'']">
          <a (click)="toggleCommentArea(modalData.itemConfig.id)">
            <span class="ya-caption" langkey="phWebshop_Item_Show_Comment"></span>
          </a>
        </div>
      </div>
    </ng-container>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <ng-container *ngIf="!modalData.isInhOuseGroupOrder then DefaultOptions else  IHGroupOptions"></ng-container>
          <ng-template #DefaultOptions>
            <div class="ya-button-container">
              <button mat-flat-button (click)="continue()">
                <span langkey="phContinueShoppingDialog_Button_Continue"></span>
              </button>
            </div>
            <div class="ya-button-container">
              <button mat-stroked-button (click)="navigateToBasket()">
                <span langkey="phContinueShoppingDialog_Button_End"></span>
              </button>
            </div>
          </ng-template>
          <ng-template #IHGroupOptions>
            <div class="ya-button-container">
              <button mat-flat-button (click)="addToGroupBasket()">
                <span langkey="phContinueShoppingDialog_Button_IHGroup_AddToGroupBasket"></span>
              </button>
            </div>
            <div class="ya-button-container">
              <button mat-stroked-button (click)="orderDirectly()">
                <span langkey="phContinueShoppingDialog_Button_IHGroup_orderDirectly"></span>
              </button>
            </div>
            <div class="ya-button-container">
              <button mat-stroked-button (click)="groupOverview()">
                <span langkey="phContinueShoppingDialog_Button_IHGroup_Overview"></span>
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>